<div class="container"
[ngClass]="{'drag-over': isDragOver}" 
(dragover)="onDragOver($event)" 
(drop)="onDrop($event)" 
(dragleave)="onDragLeave($event)" >

  <div class="header-label">Add your insights and knowledge</div>
  <div class="sub-header-label">Upload any kind of data set you already have. It might be interview video, script, pdf report or just your personal input.</div>
  <div class="label">Upload your files</div>
  <div class="drop-frame">
      <div class="drop-frame-icon">
        <img src="../assets/file-text.svg" />
      </div>
      <div class="drop-frame-text center">
        Drop files here to upload them <br/>or <label for="fileInput" class="select-files">select files manually</label>
      </div>
  </div>
  <div class="drop-frame-text">
    Supported formats: .jpg, .png, .jpeg, .gif, .pdf, .txt, .csv, Office documents, .wav, .mp3, mp4, .mpg
  </div>
  <input type="file" id="fileInput" #fileInput (change)="onFileSelect($event)" hidden multiple>

  <div class="label">Upload your files</div>
  <div class="file-list">
    @for (file of filesArray; track $index) {
      <div class="file-item">
        <div class="file-item-name">{{ file.name }}</div>
        <button class="file-item-delete" (click)="deleteFile(file)"></button>
      </div>
    }
  </div>

  @if (isCloseButtonVisible == true) {
      <button class="file-button" (click)="close()">
        <i class="bi bi-x-circle"></i>
      </button>
  }
  <button class="file-button" (click)="uploadFiles()">Upload files</button>
  </div>
